import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import telematicsService from "../../../api/telematics.service";
import smsService from "../../../api/reservePlanNew.service";
import moment from "moment";
export default {
  name: "service-call-report",
  components: { pageheader },
  data() {
    return {
      input: {},
      reportsList: [],
      selected: [
        "Dates",
        "Equipment",
        "Geofence",
        "Group",
        "Jobsite",
        "Model",
        "Search Field",
      ],
      selectedMachine: [],
      filterTypes: [
        { id: "1", name: "Dates" },
        { id: "2", name: "Equipment" },
        { id: "3", name: "Geofence" },
        { id: "4", name: "Group" },
        { id: "5", name: "Jobsite" },
        { id: "6", name: "Model" },
        { id: "7", name: "Search Field" },
      ],
      isReportLoading: false,
      loadingMachines: false,
      machineSearchFilter: null,
      machines: [],
      zoneSearchFilter: "",
      groupSearchFilter: "",
      groups: [],
      selectedGroup: [],
      jobSiteSearchFilter: "",
      locations: [],
      loadinglocations: false,
      selectedJobSite: [],
      selectedJobSiteNames: [],
      selectedZone: [],
      zonesList: [],
      modelSearchFilter: "",
      models: [],
      selectedModel: [],
      searchMenu: false,
      searchEquipName: "",
      searchPO: "",
      searchJob: "",
      searchContractId: "",
      nodataMachine: false,
      showmachinmsg: true,
      fromDate: "",
      toDate: new Date().toISOString().slice(0, 10),
      search: "",
      menu1: false,
      menu2: false,
      isReportExporting: false,
      showTable: false,
      header: [
        { text: "Access Control Code", value: "accessControlCode", sortable: true, width: "160px" },
        { text: "Equipment #", value: "itemKey" },
        { text: "Equipment", value: "itemName", width: "200px" },
        { text: "Contract #", value: "cntr" },
        { text: "Contract Status", value: "status" },
        { text: "Open Date", value: "openedDate" },
        { text: "Closed Date", value: "closedDate" },
        { text: "Contract Info", value: "contractInfo", width: "200px" },
        { text: "Jobsite", value: "jobsite", width: "150px" },
        { text: "Job #", value: "jobNo", width: "200px" },
        { text: "PO #", value: "poNo", width: "200px" },
        { text: "Transaction Type", value: "transactionType" },
        { text: "Operation", value: "transactionOperation", width: "200px" },
        { text: "Comment", value: "comment" },
      ],
      smsCustomersList: [],
      selectedSMSCustomer: "",
      isCustLoad: false,
      csvName: "ServiceCall.xlsx",
      pdfName: "ServiceCall.pdf",
      isDownloadCSV: false,
      custNum: "33621", // This is hardcoded to REPAIRS-SERVICE - ISO
      commentDialog: false,
      closeOnContentClick: false,
      serviceComment: "",
      exportOptions: ["Excel", "PDF"],
      selectedExportOption: null,
      isDownloading: false,
      errorMSG: "Please select customer to run the report",
      menufilter: false,
      loading: false,
    };
  },
  watch: {
    machineSearchFilter(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
    machineSearchFilterSchedule(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
  },
  computed: {
    ...mapGetters([
      "roles",
      "smsCNum",
      "smsCustomerId",
      "smsUserId",
      "smsCustomerLinkingId",
      "companyNameDropdown",
    ]),
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      }
    },
    formatTimeStamp: function (val) {
      return moment.utc(val * 1000).format("HH:mm:ss");
    },
  },
  mounted() {
    this.input = utils.getInputContent("serviceCallReport", this.roles);

    this.getGroups();
    this.getLocations();
    this.getModels();
    this.getZones();
  },
  methods: {
    getList(item, queryText, itemText) {
      return itemText
        .toLocaleLowerCase()
        .startsWith(queryText.toLocaleLowerCase().trim());
    },
    mindate() {
      return new Date(new Date().getFullYear() - 2, 0, 1)
        .toISOString()
        .slice(0, 10);
    },
    maxdate() {
      return new Date().toISOString().slice(0, 10);
    },
    async getReportList() {
      this.isReportLoading = true;
      try {
        let response = await smsService.getServiceCallReport(
          this.fromDate,
          this.toDate,
          this.selectedMachine,
          this.selectedZone,
          this.selectedGroup,
          this.selectedJobSiteNames,
          this.selectedModel,
          this.searchEquipName,
          this.searchPO,
          this.searchJob,
          this.searchContractId,
        );
        if (response.isSuccess && response.data.length > 0) {
          this.showTable = true;
          this.reportsList = response.data;
          this.isReportLoading = false;
        } else {
          this.reportsList = [];
          this.isReportLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
      }
    },
    clearFilters() {
      this.fromDate = "";
      this.toDate = new Date().toISOString().slice(0, 10);
      this.reportsList = [];
      this.selectedGroup = [];
      this.selectedMachine = [];
      this.selectedModel = [];
      this.selectedZone = [];
      this.selectedJobSite = [];
      this.selectedJobSiteNames = [];
      this.searchEquipName = "";
      this.searchPO = "";
      this.searchJob = "";
      this.searchContractId = "";
      this.getReportList();
    },
    async downloadReport(exportOption) {
      try {
        let response = await smsService.exportServiceCall(
          exportOption,
          this.fromDate,
          this.toDate,
          this.selectedMachine,
          this.selectedZone,
          this.selectedGroup,
          this.selectedJobSiteNames,
          this.selectedModel,
          this.searchEquipName,
          this.searchPO,
          this.searchJob,
          this.searchContractId,
        );
        if (response) {
          if (exportOption == this.exportOptions[0]) {
            //excel
            utils.downloadExcelFile(response, this.csvName);
          } else {
            //pdf
            utils.downloadPDFFile(response, this.pdfName);
          }
        } else {
          this.$toast.error(
            "Unable to download the report. Please contact admin.",
          );
        }
        this.isDownloading = false;
      } catch (error) {
        this.$toast.error(
          "Unable to download the report. Please contact admin.",
        );
        this.isDownloading = false;
      }
    },
    exportIconClick(item) {
      this.selectedExportOption = item;
      if (this.selectedExportOption) {
        this.isDownloading = true;
        //case  "excel"
        if (this.selectedExportOption == this.exportOptions[0]) {
          this.downloadReport(this.exportOptions[0]);
        } else if (this.selectedExportOption == this.exportOptions[1]) {
          //case  "Pdf"
          this.downloadReport(this.exportOptions[1]);
        }
      }
    },
    async searchMachines(value) {
      let machineValue = "";
      machineValue = encodeURIComponent(value);
      this.machines = [];
      try {
        this.loading = true;
        let response = await telematicsService.getTelematicMachinesnew(
          machineValue,
        );
        if (response && response.data.length != 0) {
          this.machines = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              tuUnitId: item.tuUnitId ? item.tuUnitId : "",
              machine: String(index),
              stockKey: item.stockKey ? item.stockKey : "",
            };
          });
          this.loading = false;
        } else {
          this.nodataMachine = true;
          this.showmachinmsg = false;
          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        this.nodataMachine = true;
        this.showmachinmsg = false;
        console.log(err);
      }
    },
    async getZones() {
      try {
        let response = await telematicsService.getZones();
        if (response && response.data) {
          this.zonesList = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              Zone: String(index),
            };
          });
        } else {
          this.zonesList = [];
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGroups() {
      try {
        this.loading = true;
        let response = await telematicsService.getGroups();
        if (response) {
          this.groups = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",

              group: String(index),
            };
          });

          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getLocations() {
      try {
        this.loadinglocations = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.locations = response.data.filter((e) => e.locationName != null);
          this.loadinglocations = false;
        }
      } catch (err) {
        this.loadinglocations = false;
        console.log(err);
      }
    },
    async getModels() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getModels();
        if (response) {
          this.models = response.data.map((item, index) => {
            return {
              name: item ? item : "",
              id: item ? item : "",

              model: String(index),
            };
          });

          this.loadingmodel = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getJobSites() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.jobSiteList = response.data.filter(
            (e) => e.locationName != null,
          );
        } else {
          this.jobSiteList = [];
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    clearDates() {
      if (this.fromDate) {
        this.fromDate = "";
      }
      if (this.toDate) {
        this.toDate = "";
      }
    },
    resetGroup() {
      this.selectedGroup = [];
    },
    resetMachine() {
      this.selectedMachine = [];
    },
    resetZone() {
      this.selectedZone = [];
    },
    resetJobSite() {
      this.selectedJobSite = [];
      this.jobSiteChange();
    },
    resetModel() {
      this.selectedModel = [];
    },
    clearSearchEquipName() {
      this.searchEquipName = "";
    },
    clearSearch() {
      this.searchPO = "";
    },
    clearSearchJob() {
      this.searchJob = "";
    },
    clearSearchContractId() {
      this.searchContractId = "";
    },
    zoneChange() {
      this.selectedZonesNames = [];
      this.selectedZonesNames = this.selectedZone.map(
        (id) => this.zonesList.find((el) => el.id == id).name,
      );
    },
    modelChange() {
      this.selectedModelNames = [];
      this.selectedModelNames = this.selectedModel.map(
        (id) => this.models.find((el) => el.id == id).name,
      );
    },
    jobSiteChange() {
      this.selectedJobSiteNames = [];
      this.selectedJobSiteNames = this.selectedJobSite.map(
        (locationId) =>
          this.locations.find((el) => el.locationId == locationId).locationName,
      );
    },
  },
};
